<template>
<div v-if="this.$store.state.is_auth">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<div v-if="dataInfo && 'title' in dataInfo" class="w5-info">
		
			<!-- Account -->
			<div v-if="Account" class="info-block with-flex">

				<div v-if="Account['account_name'] && Account['account_name']['value']" class="info-box brd-gray" :class="recountClass('Account')">
					<span class="info-box-icon bg-gray"><font-awesome-icon icon="list-alt" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Account['account_name']['title'] | ftc }}</span>
						<!-- глобальный фильтр по акк -->
						<template v-if="$store.state.user_type === 'admin'">
							<font-awesome-icon v-if="!Account['global_filter'] || Account['global_filter']['value'] != Account['account_id']['value']"
								class="global-filter-button"
								:title="'account/filter' | ftc"
								@click="setAccountGlobalFilter(Account['account_id']['value'])"
								icon="filter"
							/>
							<font-awesome-layers v-if="Account['global_filter'] && Account['global_filter']['value'] == Account['account_id']['value']"
								class="global-filter-button global-filter-button-remove"
								:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
								@click="setAccountGlobalFilter()">
								<font-awesome-icon icon="filter" />
								<font-awesome-icon icon="times" />
							</font-awesome-layers>
						</template>
						<span class="info-box-value">{{ Account['account_name']['value'] | ftc }}</span>
					</div>
				</div>
					
				<div v-if="Account['account_created'] && Account['account_created']['value']" class="info-box brd-gray" :class="recountClass('Account')">
					<span class="info-box-icon bg-gray"><font-awesome-icon icon="calendar-alt" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Account['account_created']['title'] | ftc }}</span>
						<span class="info-box-value">{{ Account['account_created']['value'] | date('d.m.Y') }}</span>
					</div>
				</div>

				<div v-if="Account['forecast'] && Account['forecast']['value']" class="info-box brd-gray" :class="recountClass('Account')">
					<span class="info-box-icon bg-gray"><font-awesome-icon icon="exclamation-circle" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Account['forecast']['title'] | ftc }}</span>
						<span class="info-box-value">{{ Account['forecast']['value'] | date('d.m.Y') }}</span> &nbsp; <notice :text="'main/forecast_notice' | ftc" :index="'infoForeCast'" :small="true" />
					</div>
				</div>

			</div>

			<!-- Balance -->
			<div v-if="Balance" class="info-block with-flex">

				<div class="info-box brd-aqua" :class="recountClass('Balance')">
					<span class="info-box-icon bg-aqua"><font-awesome-icon :icon="AppName == 'vdsina.com' ? 'dollar-sign' : 'ruble-sign'" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Balance['real']['title'] | ftc }}</span>
						<span class="info-box-value" :class="{ 'color-red': Balance['real']['value'] < 0 }"><Money :value="Balance['real']['value'] | money_1(Balance['digits'])" /> <span v-html="localeFtc('main/ruble')"></span></span>
					</div>
				</div>

				<div class="info-box brd-aqua" :class="recountClass('Balance')">
					<span class="info-box-icon bg-aqua"><font-awesome-icon icon="piggy-bank" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Balance['bonus']['title'] | ftc }}</span>
						<span class="info-box-value" :class="{ 'color-red': Balance['bonus']['value'] < 0 }"><Money :value="Balance['bonus']['value'] | money_1(Balance['digits'])" /> <span v-html="localeFtc('main/ruble')"></span></span>
					</div>
				</div>

				<div class="info-box brd-aqua" :class="recountClass('Balance')">
					<span class="info-box-icon bg-aqua"><font-awesome-icon icon="briefcase" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Balance['partner']['title'] | ftc }}</span>
						<span class="info-box-value" :class="{ 'color-red': Balance['partner']['value'] < 0 }"><Money :value="Balance['partner']['value'] | money_1(Balance['digits'])" /> <span v-html="localeFtc('main/ruble')"></span></span>
					</div>
				</div>

			</div>

			<!-- Globals -->
			<div v-if="Globals" class="info-block with-flex">

				<div v-if="'can_add_service' in Globals && typeof Globals['can_add_service'] === 'object' && 'value' in Globals['can_add_service']" class="info-box brd-yellow" :class="recountClass('Globals')">
					<span class="info-box-icon bg-yellow"><font-awesome-icon icon="check" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Globals['can_add_service']['title'] | ftc }}</span>
						<span class="info-box-value">{{ Globals['can_add_service']['value'] | ftc }}</span>
					</div>
				</div>

				<div v-if="'can_add_user' in Globals && typeof Globals['can_add_user'] === 'object' && 'value' in Globals['can_add_user']" class="info-box brd-yellow" :class="recountClass('Globals')">
					<span class="info-box-icon bg-yellow"><font-awesome-icon icon="users" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Globals['can_add_user']['title'] | ftc }}</span>
						<span class="info-box-value">{{ Globals['can_add_user']['value'] | ftc }}</span>
					</div>
				</div>

				<div v-if="'can_convert_to_cash' in Globals && typeof Globals['can_convert_to_cash'] === 'object' && 'value' in Globals['can_convert_to_cash']" class="info-box brd-yellow" :class="recountClass('Globals')">
					<span class="info-box-icon bg-yellow"><font-awesome-icon icon="exchange-alt" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Globals['can_convert_to_cash']['title'] | ftc }}</span>
						<span class="info-box-value">{{ Globals['can_convert_to_cash']['value'] | ftc }}</span>
					</div>
				</div>
					
			</div>

			<!-- Bonus -->
			<div v-if="Bonus" class="info-block with-flex">

				<div v-if="Bonus['value'] && Array.isArray(Bonus['value']) && Bonus['value'].length" class="info-box for-bonus brd-green">
					<span class="info-box-icon bg-green"><font-awesome-icon icon="gift" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Bonus['title'] | ftc }}</span>
						<span class="info-box-value-bonuses">
							<template v-for="(b, i) in Bonus['value']">
								<span v-if="i > 0">, </span><linkComponent :url="'/bonus/view/' + b['bonus_id']" :text="b['bonus_name']" :class="!b['active'] ? 'not-active-bonus' : ''" />
							</template>
						</span>
					</div>
				</div>

			</div>

			<!-- Partner -->
			<div v-if="Partner || Program" class="info-block with-flex">

				<div v-if="Partner['account_id'] && Partner['account_id']['value'] && Partner['account_name'] && Partner['account_name']['value']"
					class="info-box brd-dark-blue" :class="recountClass('Partner')">
					<span class="info-box-icon bg-dark-blue"><font-awesome-icon icon="user-graduate" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Partner['account_id']['title'] | ftc }}</span>
						<span class="info-box-value-bonuses">
							<!-- глобальный фильтр по акк -->
							<template v-if="$store.state.user_type === 'admin'">
								<font-awesome-icon v-if="!Account['global_filter'] || Account['global_filter']['value'] != Partner['account_id']['value']"
									class="global-filter-button"
									:title="'account/filter' | ftc"
									@click="setAccountGlobalFilter(Partner['account_id']['value'], true)"
									icon="filter"
								/>
								<font-awesome-layers v-if="Account['global_filter'] && Account['global_filter']['value'] == Partner['account_id']['value']"
									class="global-filter-button global-filter-button-remove"
									:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
									@click="setAccountGlobalFilter()">
									<font-awesome-icon icon="filter" />
									<font-awesome-icon icon="times" />
								</font-awesome-layers>
							</template>
							<linkComponent :url="'/account/view/' + Partner['account_id']['value']" :text="Partner['account_name']['value']" />
						</span>
					</div>
				</div>

				<div v-if="Program['program_id'] && Program['program_id']['value'] && Program['program_name'] && Program['program_name']['value']"
					class="info-box brd-dark-blue" :class="recountClass('Partner')">
					<span class="info-box-icon bg-dark-blue"><font-awesome-icon icon="handshake" /></span>
					<div class="info-box-content">
						<span class="info-box-text">{{ Program['program_id']['title'] | ftc }}</span>
						<span class="info-box-value-bonuses">
							<linkComponent :url="'/partnerprogram/view/' + Program['program_id']['value']" :text="Program['program_name']['value']" />
						</span>
					</div>
				</div>

			</div>



			<!-- Limits -->
			<limits :data="Limits" />

		</div>

	</template>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
//import Vue from 'vue'
import { EventBus } from '@/bus.js'
import viewComponent from '@/components/elements/view'
import limits from '@/components/elements/limits'
import notice from '@/components/elements/notice'
import Money from '@/components/elements/money'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Info',
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// закешированные данные
			dataInfo: false,

			// наименование CRUD-объекта
			crud: 'info',

			// отсортированные данные
			sortDATA: {},

			// ключи полей
			Keys: false,

			// локальное сообщение об ошибке
			localErrorMessage: ''
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			return this.$store.state.clientConfig
		},
		// Account
		Account() {
			if (this.dataInfo && this.dataInfo['account']) return this.dataInfo['account']
			else return false
		},
		// Balance
		Balance() {
			if (this.$store.state.user_type === 'admin')
			{
				return {
					'digits': this.countBalanceDigits(),
					'real': {
						'value': this.Account['balance']['real']['value'],
						'title': 'operation/purse_real'
					},
					'bonus': {
						'value': this.Account['balance']['bonus']['value'],
						'title': 'operation/bonus_balance'
					},
					'partner': {
						'value': this.Account['balance']['partner']['value'],
						'title': 'operation/partner_balance'
					}
				}
			}
			else
			{
				if (this.$store.state.user_balance && 'real' in this.$store.state.user_balance)
				{
					return {
						'digits': this.countBalanceDigits(),
						'real': {
							'value': this.$store.state.user_balance['real'],
							'title': 'operation/purse_real'
						},
						'bonus': {
							'value': this.$store.state.user_balance['bonus'],
							'title': 'operation/bonus_balance'
						},
						'partner': {
							'value': this.$store.state.user_balance['partner'],
							'title': 'operation/partner_balance'
						}
					}
				}
				else return false
			}
		},
		// Globals
		Globals() {
			if (this.dataInfo && this.dataInfo['globals']) return this.dataInfo['globals']
			else return false
		},
		// Bonus
		Bonus() {
			if (this.dataInfo && this.dataInfo['bonus']) return this.dataInfo['bonus']
			else return false
		},
		// Partner
		Partner() {
			if (this.$store.state.user_type !== 'admin') return false
			if (this.dataInfo && this.dataInfo['partner']) return this.dataInfo['partner']
			else return false
		},
		// Program
		Program() {
			if (this.$store.state.user_type !== 'admin') return false
			if (this.dataInfo && this.dataInfo['program']) return this.dataInfo['program']
			else return false
		},
		// Limits
		Limits() {
			if (this.dataInfo && this.dataInfo['limits']) return this.dataInfo['limits']
			else return false
		},
		// Настоящее название CRUD
		realCrudName() {
			// определим частные случаи
			if (this.crud === 'admin') return 'user'
			if (this.crud === 'partnerprogram') return 'program'
			if (this.crud === 'servicetype') return 'service_type'
			if (this.crud === 'planarchive') return 'plan'
			if (this.crud === 'iso') return 'service'
			if (this.crud === 'additional-services') return 'service'

			// если это общий случай
			return this.crud
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// сразу запрашиваем данные формы
		this.requestInfo()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		window.addEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		window.removeEventListener('storage', this.onLocalStorageEvent)
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			this.requestInfo()
		}
	},
	//=========================================================================
	// метолы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestInfo() {
			let _url = this.APIServerUrl + '/account/view'
			if (this.$store.state.user_type === 'admin') _url = this.APIServerUrl + this.$route.path
			// делаем запрос
			this.$http.get(_url).then(
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok')
					{
						this.dataInfo = Object.assign({}, _dt)
						// сортировка
						this.sortDATA = this._order()
						// ключи полей
						this.Keys = Object.keys(this.sortDATA).sort(function(a, b) {
							return a - b
						})
						// если клиент - обновим данные об остатках
						if (this.$store.state.user_type !== 'admin')
						{
							if (_dt['account'] && _dt['account']['balance'])
							{
								this.$store.commit('updateUserBalance', _dt['account'])
							}
						}
						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(res)
				},
				res => { this.localErrorMessage = this.formatRequestError(res) }
			)
		},
		//---------------------------------------------------------------------
		// вычисление стиля для блока
		//---------------------------------------------------------------------
		recountClass(what) {
			if (what === 'Account')
			{
				let _cnt = 0
				if (this.Account['account_name']['value']) _cnt++
				if (this.Account['account_created']['value']) _cnt++
				if (this.Account['forecast']['value']) _cnt++
				return 'info-box-width-' + _cnt
			}

			if (what === 'Balance')
			{
				return 'info-box-width-3'
			}

			if (what === 'Globals')
			{
				let _cnt = 0
				if (this.Globals['can_add_service']) _cnt++
				if (this.Globals['can_add_user']) _cnt++
				if (this.Globals['can_convert_to_cash']) _cnt++
				return 'info-box-width-' + _cnt
			}

			if (what === 'Partner')
			{
				let _cnt = 0
				if (this.Partner && this.Partner['account_id'] && this.Partner['account_id']['value']) _cnt++
				if (this.Program && this.Program['program_id'] && this.Program['program_id']['value']) _cnt++
				return 'info-box-width-' + _cnt
			}

			return false
		},
		//---------------------------------------------------------------------
		// подсчет количества знаков
		//---------------------------------------------------------------------
		countBalanceDigits() {
			let _r = String(this.Account['balance']['real']['value']).split('.')
			let _b = String(this.Account['balance']['bonus']['value']).split('.')
			let _p = String(this.Account['balance']['partner']['value']).split('.')

			_r = _r[1] ? _r[1].length : 0
			_b = _b[1] ? _b[1].length : 0
			_p = _p[1] ? _p[1].length : 0

			_r = Math.max(_r, _b, _p)
			if (_r > 2) return 4
			return 2
		},
		//---------------------------------------------------------------------
		// сортирует данные согласно порядку
		//---------------------------------------------------------------------
		_order() {
			let obj
			let __obj
			let tmp
			let order
			let sortDATA = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем данным
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let idx in this.Limits) if (this.Limits.hasOwnProperty(idx))
			{
				// текущий объект
				obj = this.Limits[idx]

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// рассматриваем только объекты
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				if (obj && typeof obj === 'object')
				{
					// если уже есть порядок
					if ('order' in obj && obj['type'] !== 'hidden')
					{
						// получим индекс
						tmp = parseInt(obj['order'])
						order = isNaN(tmp) ? 0 : tmp

						// запомним его
						if (!sortDATA[order])
						{
							sortDATA[order] = []
							sortDATA[order].push(idx)
						}
						else sortDATA[order].push(idx)
					}
					// порядка еще нет - опускаемся на уровень ниже
					else
					{
						for (let i in obj) if (obj.hasOwnProperty(i))
						{
							// текущий объект
							__obj = obj[i]

							// рассматриваем только объекты
							if (__obj && typeof __obj === 'object' &&
								'order' in __obj &&
								'title' in __obj &&
								'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined &&
								'type' in __obj && __obj['type'] !== 'hidden')
							{
								// получим индекс
								tmp = parseInt(__obj['order'])
								order = isNaN(tmp) ? 0 : tmp

								// запомним его
								if (!sortDATA[order])
								{
									sortDATA[order] = []
									sortDATA[order].push(i)
								}
								else sortDATA[order].push(i)
							}
						}
					}
				}

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// возвращаем результат
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return sortDATA
		},
		//---------------------------------------------------------------------
		// установка/снятие глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(account, isPartner) {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// если это установка фильтра
			if (account)
			{
				if (!/\d+/.test(account)) return
				let _accountID = parseInt(account)
				if (isNaN(_accountID) || _accountID < 1) return

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// генерируем событие установки глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'main/set_filter ' + (isPartner === true ? this.Partner['account_name']['value'] : this.Account['account_name']['value']),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// рефрешим
							this.requestInfo()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
			// если это очистка глобального фильтра
			else
			{
				// начинаем очистку фильтра - готовим URL согласно API
				let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

				// делаем сам запрос
				this.$http.get(_url).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// обнуляем флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', false)

							// генерируем событие снятия глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр удален
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': this.localeFtc('main/filter') + ' ' + this.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// рефрешим
							this.requestInfo()

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return
			// не задан аккаунт
			if (!this.Account || !this.Account['account_id'] || !this.Account['account_id']['value'])
				return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length !== 4) return

			// нужно обрабатывать только обновления балансов
			if (_parts[0] !== 'update' || _parts[1] !== 'operation' || !_parts[2]) return

			// обновляем данные только если эта операция по текущему аккаунту
			if (String(this.Account['account_id']['value']) === _parts[3])
			{
				// обновим данные
				this.requestInfo()
			}
		},

		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// если это установка фильтра
				if (event.newValue.indexOf('agf1') === 0)
				{
					// получим текущий аккаунт который просматривают
					let _curAcc = this.$route && this.$route.params && this.$route.params.id
						? this.$route.params.id
						: null
					// и аккаунт по которому установлен фильтр
					let _fltAcc = event.newValue.split('_')[1]
					// если мы в просмотре другого аккаунта
					if (_curAcc && _fltAcc &&
						String(_curAcc) !== String(_fltAcc))
					{
						// просто переходим в просмотр нового аккаунта
						this.$router.replace('/account/view/' + _fltAcc)
						// на этом все
						return
					}
				}

				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// рефрешим
				this.requestInfo()
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		viewComponent,
		limits,
		notice,
		Money
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-info {	
	margin-top: 20px;
}

.info-block {
	width: 100%;
	margin: 10px 0;
	padding: 0;
	background-color: #fff;
	border: 1px solid #eee;
	border-radius: 4px;
}

.info-block.with-flex {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: flex-start;
	-webkit-align-items: flex-start;
}

.info-block.for-limits {
	padding: 0px 0px 10px 10px;
}

.info-box-width-1 { width: 100% !important }
.info-box-width-2 { width: 49% !important }
.info-box-width-3 { width: 32% !important }
.info-box-width-4 { width: 24% !important }

.info-box {
    display: block;
    height: 60px;
    background: #fff;
	border: 1px solid transparent;    
    margin: 10px;
}

.info-box.for-bonus {
	width: 100%;
	height: auto;
	min-height: 58px;
}

.info-box-icon {
    display: block;
    float: left;
    height: 58px;
    width: 58px;
    text-align: center;
    font-size: 20px;    
    background: rgba(0,0,0,0.2);
}

.info-box-icon > svg {
	color: white;
	margin-top: 19px;
}

.info-box-content {
	height: auto;	
    padding: 5px 0 5px 10px;
    margin-left: 58px;
    min-height: 58px;
}

.info-box-content.bonus-item {
	padding: 5px 0 5px 5px;
    margin-left: 0;
}

.info-box-text {
    display: block;
    margin-top: 0px;
    font-size: 13px;
    line-height: 0.8;    
    color: #66afe9;
}

.info-box-value {
	display: inline-block;
	margin-top: 8px;
    font-weight: 500;
    font-size: 14px;
}

.info-box-value-bonuses {
	display: inline-block;
	margin-top: 10px;
	line-height: 0.9;
	font-weight: 500;
    font-size: 14px;
}


.bg-gray {
    background-color: #a0c0c0 !important;
}

.bg-aqua {
    background-color: #00c0ef !important;
}
.w5-application.mc .bg-aqua {
    background-color: #fc688a !important;
}

.bg-green {
    background-color: #00a65a !important;
}

.bg-yellow {
    background-color: #f39c12 !important;
}

.bg-red {
    background-color: #dd4b39 !important;
}

.bg-dark-blue {
	background-color: #607d8b !important;
}


.brd-gray {
    border-color: #a0c0c0 !important;
}

.brd-aqua {
    border-color: #00c0ef !important;
}
.w5-application.mc .brd-aqua {
    border-color: #fc688a !important;
}

.brd-green {
    border-color: #00a65a !important;
}

.brd-yellow {
    border-color: #f39c12 !important;
}

.brd-red {
    border-color: #dd4b39 !important;
}

.brd-dark-blue {
	border-color: #607d8b !important;
}

@media (max-width: 767px) {
	.info-block.for-limits > .w5-form-row > .w5-view-field {
	    width: 100% !important;
	    padding-right: 10px;
	}

	.info-block.with-flex {
	    -webkit-box-orient: vertical;
	    -webkit-box-direction: normal;
	    -ms-flex-direction: column;
	    flex-direction: column;
	    width: 100% !important;
	}

	.info-box-width-2 { width: calc(100% - 20px) !important }
	.info-box-width-3 { width: calc(100% - 20px) !important }
	.info-box-width-4 { width: calc(100% - 20px) !important }
	.info-box.for-bonus { width: calc(100% - 20px) !important }
}

@media (min-width: 768px) and (max-width: 1024px) {
	.info-box-text {
		font-size: 11px;
	}
}

</style>



// WEBPACK FOOTER //
// Info.vue?facc081a